<template>
    <div>
        <div class="ui main text container">
          <div class="ui grid">
            <div class="sixteen column row">
              <div class="sixteen wide column">
                <div class="ui segment">
                  <h1 class="ui header">Account Codes</h1>
                  <table class="ui celled table">
                    <thead>
                      <tr><th>Name</th>
                      <th>Code</th>
                      <th>Status</th>
                    </tr></thead>
                    <tbody>
                      <tr v-for="(accountCode, index) in accountCodes" :key="index">
                        <td data-label="Name">{{ accountCode.name }}</td>
                        <td data-label="Code">{{ accountCode.code }}</td>
                        <td data-label="Status" v-on:click="toggleCode(index)"><a href="#">{{ accountCode.status }}</a></td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="ui action fluid input">
                    <input v-model="newCodeName" type="text" placeholder="Account Name">
                    <button class="ui green button" v-on:click="createNewCode()">Create New Code</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
  import { twosteau } from './mixins/clients/twosteau.js'

  export default {
    name: 'AccountCodes',
    mixins: [twosteau],
    data: function () {
      return {
        accountCodes: [],
        newCodeName: ''
      }
    },
    methods: {
      getIdToken: function () {
        return localStorage.id_token
      },
      getCodes: function () {
        this.accountCodes = this.getAccountCodes(this.getIdToken())
        this.$on('accountCodesReceived', function (data) {
          this.accountCodes = data
        })
      },
      createNewCode: function () {
        var v = this
        var newCode = { name: v.newCodeName, status: 'ACTIVE' }
        v.postAccountCode(newCode, v.getIdToken)
        this.$on('accountCodePosted', function (data) {
          v.getCodes()
        })
        v.newCodeName = ''
      },
      toggleCode: function (index) {
        var v = this
        var selectedCode = Object.assign({}, v.accountCodes[index])
        if (selectedCode.status === 'ACTIVE') {
          selectedCode.status = 'INACTIVE'
        } else {
          selectedCode.status = 'ACTIVE'
        }
        v.putAccountCode(selectedCode, v.getIdToken)
        this.$on('accountCodePut', function (data) {
          v.getCodes()
        })
      }
    },
    mounted () {
      this.getCodes()
    }
  }
</script>
<style>
  a {
    cursor: pointer;
  }
  body {
    background-color: #FFFFFF;
  }
  .ui.menu .item img.logo {
    margin-right: 1.5em;
  }
  .main.container {
    margin-top: 7em;
  }
  .wireframe {
    margin-top: 2em;
  }
  .ui.footer.segment {
    margin: 5em 0em 0em;
    padding: 5em 0em;
  }
  .ui.fluid.primary.button.reqbutton, .ui.fluid.positive.button.reqbutton, .ui.fluid.secondary.button.reqbutton {
    margin-bottom: 0.5em;
    margin-top: 0.5em;
  }
</style>
    



// WEBPACK FOOTER //
// src/components/AccountCodes.vue